import { render, staticRenderFns } from "./Emailhome.vue?vue&type=template&id=3948d8d4&scoped=true&"
import script from "./Emailhome.vue?vue&type=script&lang=js&"
export * from "./Emailhome.vue?vue&type=script&lang=js&"
import style0 from "./Emailhome.vue?vue&type=style&index=0&id=3948d8d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3948d8d4",
  null
  
)

export default component.exports